








































import { createComponent } from "@vue/composition-api";
import { getActions } from "@dcc/store/drinking/actions";
import { useRouting } from "@dcc/compositions/useRouting";
import {
  BaseActionButton,
  BaseActionButtonGroup,
  BaseLink
} from "@web-components";
import { findGetters } from "@dcc/store/drinking/getters";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
export default createComponent({
  components: {
    BaseActionButton,
    BaseActionButtonGroup,
    BaseLink
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();
    const { getDrinkFrequency } = findGetters(context.root.$store);
    const drinkFrequency = getDrinkFrequency();

    const { updateDrinkFrequency } = getActions(context.root.$store);
    const handleSelected = (value: number) => {
      updateDrinkFrequency(value);
      handleNext();
    };
    return {
      handleSelected,
      handlePrev,
      DrinkFrequency,
      drinkFrequency,
      ...dictionary
    };
  }
});
